import { connect } from 'react-redux';
import AddInspectionDialog from './AddInspectionDialog';

import { getInspectionTypeBegin } from 'src/store/actions/license.actions';
import { getInspectionType, getUserList } from 'src/store/selectors/license.selectors';
import { getLoggedInUser } from 'src/store/selectors/authentication.selectors';
import { getAddInspectionFormByIdBegin } from 'src/store/actions/inspection.actions';
import { getAddInspectionForm, isAddInspectionFormLoading } from 'src/store/selectors/inspection.selectors';
import { closeBulkViolationsBegin, getOpenedViolationsBegin } from 'src/store/actions/violation.actions';
import { getOpenedViolations, getOpenedViolationsLoading } from 'src/store/selectors/violation.selectors';

const mapStateToProps = (state: any) => {
    const inspectionTypesList = getInspectionType(state);
    const inspectors = getUserList(state);
    const loggedInUser = getLoggedInUser(state);
    const addInspectionForm = getAddInspectionForm(state);
    const loading = isAddInspectionFormLoading(state);
    const openedViolations = getOpenedViolations(state);
    const openedViolationsLoading = getOpenedViolationsLoading(state);
    return {
        loading,
        inspectors,
        loggedInUser,
        openedViolations,
        addInspectionForm,
        inspectionTypesList,
        openedViolationsLoading,
    };
};
const mapDispatchToProps = {
    getInspectionTypeList: getInspectionTypeBegin,
    getAddInspectionFormById: getAddInspectionFormByIdBegin,
    getOpenedViolations: getOpenedViolationsBegin,
    closeBulkViolations: closeBulkViolationsBegin,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddInspectionDialog);
